module.exports = __webpack_public_path__ + "static/media/success.6a38ce4d.svg";